import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-alert-error',
  templateUrl: './pop-alert-error.component.html',
  styleUrls: ['./pop-alert-error.component.scss']
})
export class PopAlertErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
